export default __webpack_public_path__ + "assets/images/0c1dd571b3341d836eb9e3af1f5e8320.png";